"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Header = _interopRequireDefault(require("../Header"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _reactI18next = require("react-i18next");
var _labeling = _interopRequireDefault(require("../../containers/labeling"));
var _finalizePaymentSlice = require("../../redux/finalizePaymentSlice");
var _OfferStyled = require("../Offer/OfferStyled");
var _ThankYouPageStyled = require("../ThankYouPage/ThankYouPageStyled");
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M93.648 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
    fill: "#cb4477"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M99.956 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
    fill: "#cb4477"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M96.016 3.096a.761.761 0 0 1-.762-.762V.762A.761.761 0 0 1 96.016 0a.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
    fill: "#cb4477"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M96.016 9.405a.761.761 0 0 1-.762-.762V7.071a.761.761 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
    fill: "#cb4477"
  })))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "m4.437 65.45-1.111-1.112a.762.762 0 0 1 0-1.078.762.762 0 0 1 1.077 0l1.112 1.112a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.078 0Z",
    fill: "#cb4477"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "m8.898 69.91-1.112-1.112a.762.762 0 0 1 0-1.077.762.762 0 0 1 1.078 0l1.111 1.111a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.077 0Z",
    fill: "#cb4477"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.784 65.45a.762.762 0 0 1 0-1.077l1.111-1.112a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.078L8.862 65.45a.762.762 0 0 1-1.078 0Z",
    fill: "#cb4477"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.323 69.91a.762.762 0 0 1 0-1.077l1.112-1.111a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.077L4.4 69.911a.762.762 0 0 1-1.078 0Z",
    fill: "#cb4477"
  }))))), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.471 5.838a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.471 6.838c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0-1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
    fill: "#cb4477"
  })), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M96.471 59.838a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M96.471 60.838c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0-1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
    fill: "#cb4477"
  })))))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(31 11.838)",
    fill: "#cb4477",
    stroke: "#cb4477"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.767 35.584c-3.008-6.169-8.049-14.92-12.5-22.64-2.327-4.041-4.526-7.856-6.115-10.756a4 4 0 0 0-7.129 0c-1.59 2.9-3.79 6.721-6.12 10.764C8.458 20.667 3.418 29.417.412 35.584A4.012 4.012 0 0 0 0 37.35a4.054 4.054 0 0 0 4.035 4.064h37.108a4.054 4.054 0 0 0 4.035-4.064 4.011 4.011 0 0 0-.411-1.766Zm-3.623 3.948H4.037a2.171 2.171 0 0 1-2.153-2.182 2.14 2.14 0 0 1 .221-.941c2.978-6.109 8-14.826 12.431-22.517 2.335-4.053 4.54-7.881 6.139-10.8a2.18 2.18 0 0 1 3.827 0c1.6 2.917 3.8 6.742 6.135 10.791 4.433 7.693 9.457 16.414 12.436 22.525a2.135 2.135 0 0 1 .222.942 2.171 2.171 0 0 1-2.151 2.182Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.589 9.413a.941.941 0 0 0-.941.941v18.824a.941.941 0 1 0 1.883 0V10.354a.941.941 0 0 0-.942-.941Z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: ".941",
    cy: ".941",
    r: ".941",
    transform: "translate(21.648 33.884)"
  })))));
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100.718",
  height: "73.237"
};
var FailedPaymentPage = function FailedPaymentPage(_ref) {
  var t = _ref.t;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.finalizeInitialPayment;
    }),
    error = _useSelector.error;
  var dispatch = (0, _reactRedux.useDispatch)();
  return /*#__PURE__*/_react.default.createElement(_OfferStyled.StyledOfferWrapper, {
    "data-testid": "FailedPaymentPage-component"
  }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(_ThankYouPageStyled.ThankYouPageStyled, null, /*#__PURE__*/_react.default.createElement(WarningIcon, null), /*#__PURE__*/_react.default.createElement(_ThankYouPageStyled.TitleStyled, null, t('failed-payment-page.title', "Oops! Something went wrong")), /*#__PURE__*/_react.default.createElement(_ThankYouPageStyled.MessageStyled, null, /*#__PURE__*/_react.default.createElement("strong", null, t('failed-payment-page.subtitle', "We weren't able to process your payment."))), /*#__PURE__*/_react.default.createElement(_ThankYouPageStyled.MessageStyled, null, error.includes('Refused') ? /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "failed-payment-page.desc-refused"
  }, "To complete your purchase, please", /*#__PURE__*/_react.default.createElement(_ThankYouPageStyled.LinkStyled, {
    as: "button",
    onClick: function onClick() {
      return dispatch((0, _finalizePaymentSlice.setShouldShowFinalizePaymentComponent)(false));
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, "try again"), "using a different payment method.") : /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "failed-payment-page.desc-error"
  }, "To complete your purchase, please", /*#__PURE__*/_react.default.createElement(_ThankYouPageStyled.LinkStyled, {
    as: "button",
    onClick: function onClick() {
      return dispatch((0, _finalizePaymentSlice.setShouldShowFinalizePaymentComponent)(false));
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, "try again.")))), /*#__PURE__*/_react.default.createElement(_Footer.default, null));
};
FailedPaymentPage.propTypes = {
  t: _propTypes.default.func
};
FailedPaymentPage.defaultProps = {
  t: function t(k) {
    return k;
  }
};
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()(FailedPaymentPage));
exports.default = _default;